export class EnumeratedPermission {
  display: string = "";
  type: string = "";
  value: string = "";
}

export class PermissionsEnumerationResult {
  dashboards: EnumeratedPermission[] = [];
  permissions: EnumeratedPermission[] = [];
  widgets: EnumeratedPermission[] = [];
  workflows: EnumeratedPermission[] = [];
}
